import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  HsCardModule,
  HsFormFieldModule,
  HsInputModule,
} from '@hsetu/ngui-components';
import { HsLayerModule } from '@hsetu/ngui-resources';
import { Report } from '@modules/report/models/report.model';
import { ReportService } from '@modules/report/services/report.service';

@Component({
  selector: 'kfm-print-settings-card',
  imports: [
    CommonModule,
    HsCardModule,
    HsFormFieldModule,
    HsLayerModule,
    HsInputModule,
  ],
  templateUrl: './kfm-print-settings-card.component.html',
})
export class KfmPrintSettingsCardComponent {
  private readonly _reportService = inject(ReportService);

  protected readonly title = computed(() => {
    return this.report()?.title || '';
  });

  protected readonly header = computed(() => {
    return this.report()?.header || '';
  });

  protected readonly preText = computed(() => {
    return this.report()?.preText || '';
  });

  protected readonly postText = computed(() => {
    return this.report()?.postText || '';
  });

  protected readonly footer = computed(() => {
    return this.report()?.footer || '';
  });

  public report = input.required<Report>();
  public editable = input<boolean>(true);
  public showTitle = input<boolean>(true);
  public showHeader = input<boolean>(true);
  public showPreText = input<boolean>(true);
  public showPostText = input<boolean>(true);
  public showFooter = input<boolean>(true);
  public collapsed = input<boolean>(true);

  protected onTitleChanged(value: string): void {
    const report = this.report();
    if (report) {
      report.title = value;
      this._reportService.update(report);
    }
  }

  protected onHeaderChanged(value: string): void {
    const report = this.report();
    if (report) {
      report.header = value;
      this._reportService.update(report);
    }
  }

  protected onPreTextChanged(value: string): void {
    const report = this.report();
    if (report) {
      report.preText = value;
      this._reportService.update(report);
    }
  }

  protected onPostTextChanged(value: string): void {
    const report = this.report();
    if (report) {
      report.postText = value;
      this._reportService.update(report);
    }
  }

  protected onFooterChanged(value: string): void {
    const report = this.report();
    if (report) {
      report.footer = value;
      this._reportService.update(report);
    }
  }
}
